import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { getApplicantDocument as onGetApplicantDocuments, addNewApplicantDocument as onAddNewApplicantDocument, updateApplicantDocument as onUpdateApplicantDocument, deleteApplicantDocument as onDeleteApplicantDocument, getApplicantDocumentLoading } from "../../../store/applicantDocument/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";

const ApplicantDocument = () => {
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { positions, applicantDocuments, isApplicantDocumentCreated, isApplicantDocumentSuccess, loading, error, companies, companyLoading, clientLoading, clients } = useSelector((state) => ({
    applicantDocuments: state.ApplicantDocument.applicantDocuments,
    isApplicantDocumentCreated: state.ApplicantDocument.isApplicantDocumentCreated,
    isApplicantDocumentSuccess: state.ApplicantDocument.isApplicantDocumentSuccess,
    loading: state.ApplicantDocument.loading,
    error: state.ApplicantDocument.error,
    positions: state.Position.positions,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
  }));

  const [applicantDocumentList, setApplicantDocumentList] = useState([]);
  const [applicantDocument, setApplicantDocument] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [parentList, setParentList] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [applicantDocumentFiles, setApplicantDocumentFiles] = useState([]);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });

        dispatch(onGetApplicantDocuments());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
      }
    }
  }, [dispatch, isSearch]);

  const onClickDelete = (applicantDocument) => {
    setApplicantDocument(applicantDocument);
    setDeleteModal(true);
  };

  const handleDeleteApplicantDocument = () => {
    if (applicantDocument) {
      dispatch(onDeleteApplicantDocument(applicantDocument));
      setDeleteModal(false);
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = applicantDocumentFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setApplicantDocumentFiles(newState);
    } else {
      const index = applicantDocumentFiles.findIndex((fl) => fl.filename === file.filename);

      setApplicantDocumentFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    if (!isEmpty(applicantDocumentList)) {
      let arr = [];
      applicantDocumentList.forEach((asset) => {
        arr.push({ value: asset.id, label: asset.name });
      });

    }
  }, [applicantDocumentList]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(applicantDocuments)) setApplicantDocumentList(applicantDocuments);
  }, [applicantDocuments]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredApplicantDocuments = applicantDocuments;
      if (type !== "all") {
        filteredApplicantDocuments = applicantDocuments.filter((applicantDocument) => {
          return applicantDocument.applicant_document_status.name === type;
        });
      }
      setApplicantDocumentList(filteredApplicantDocuments);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  useEffect(() => {
    setApplicantDocument(applicantDocuments);
  }, [applicantDocuments]);

  useEffect(() => {
    if (!isEmpty(applicantDocuments)) {
      setApplicantDocument(applicantDocuments);
      setIsEdit(false);
    }
  }, [applicantDocuments]);

  useEffect(() => {
    if (!isEmpty(applicantDocuments)) {
      setApplicantDocumentList(applicantDocuments);
    }
  }, [applicantDocuments]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(applicantDocuments)) {
      var data = [];
      var opt = [];
      applicantDocuments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setParentList(data);
    }
  }, [applicantDocuments]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setApplicantDocument(null);
      setApplicantDocumentFiles([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleApplicantDocumentClick = useCallback((arg) => {
    const applicantDocument = arg;
    setApplicantDocument({
      id: applicantDocument.id,
      name: applicantDocument.name,
      sort_order: applicantDocument.sort_order,
      description: applicantDocument.description,
      client: {
        label: applicantDocument.applicant_document_client.name,
        value: applicantDocument.applicant_document_client.id,
      },
      company: {
        label: applicantDocument.applicant_document_company.name,
        value: applicantDocument.applicant_document_company.id,
      },
      status: {
        label: applicantDocument.applicant_document_status.name,
        value: applicantDocument.applicant_document_status.id,
      },
    });

    setIsEdit(true);
    toggle();
  }, [toggle]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (applicantDocument && applicantDocument.client) || clientSelected,
      company: (applicantDocument && applicantDocument.company) || companySelected,
      name: (applicantDocument && applicantDocument.name) ?? "",
      status: (applicantDocument && applicantDocument.status) || { label: "ACTIVE", value: "2" },
      description: (applicantDocument && applicantDocument.description) ?? "",
      sort_order: (applicantDocument && applicantDocument.sort_order) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),
    onSubmit: (values) => {
      dispatch(getApplicantDocumentLoading());
      if (isEdit) {
        const updateApplicantDocument = {
          id: applicantDocument ? applicantDocument.id : 0,
          companyId: values.company.value,
          clientId: values.client.value,
          name: values.name,
          statusId: values.status.value,
          description: values.description,
          sort_order: values.sort_order,
        };
        dispatch(onUpdateApplicantDocument(updateApplicantDocument));
        validation.resetForm();
      } else {
        const newApplicantDocument = {
          companyId: values.company.value,
          clientId: values.client.value,
          name: values.name,
          statusId: values.status.value,
          description: values.description,
          sort_order: values.sort_order,
        };
        dispatch(onAddNewApplicantDocument(newApplicantDocument));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteApplicantDocument(element.value));
    });
    checkall.checked = false;
  };

  // Column
  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button color="light" className={
                userType === "admin"
                  ? "btn-sm"
                  : userRole &&
                    userRole.split(",").indexOf("updateApplicant") !== -1
                    ? "btn-sm"
                    : "btn-sm d-none"
              } onClick={() => {
                handleApplicantDocumentClick(data);
              }}><i className="ri-edit-2-line fs-15"></i></Button>
              <Button color="light" className={
                userType === "admin"
                  ? "btn-sm"
                  : userRole &&
                    userRole.split(",").indexOf("deleteApplicant") !== -1
                    ? "btn-sm"
                    : "btn-sm d-none"
              } onClick={() => {
                onClickDelete(data);
              }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
  },
  {
    Header: "Nama",
    accessor: "name",
    filterable: true,
  },
  {
    Header: "Grup Usaha",
    accessor: "applicant_document_client.name",
    filterable: true,
  },
  {
    Header: "No Urut",
    accessor: "sort_order",
    filterable: true,
  },
  {
    Header: "Keterangan",
    accessor: "description",
    filterable: true,
  },
  {
    Header: "Status",
    accessor: "applicant_document_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
        case "ACTIVE":
          return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
        case "INACTIVE":
          return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
        default:
          return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
      }
    },
  }], [handleApplicantDocumentClick, userRole, userType]);


  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: applicantDocumentList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleApplicantDocumentStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetApplicantDocuments(param));
  }

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };


  document.title = "Material & Upah | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={applicantDocumentList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteApplicantDocument} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Berkas KPR" pageTitle="Penjualan" />
        <Row>
          <Col lg={12}>
            <Card id="applicantDocumentList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Berkas KPR &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createApplicant") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                      id="create-btn"
                      onClick={() => {
                        setApplicantDocument("");
                        setIsEdit(false);
                        setCompanyList([]);
                        toggle();
                      }}>
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                    <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>
                    <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger add-btn" : userRole && userRole.split(",").indexOf("deleteApplicant") !== -1 ? "btn btn-soft-danger add-btn" : "btn btn-soft-danger add-btn d-none"} onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL CATEGORY
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[25, 50, 100, 150, 250, 500, 1000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""} /><i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}><i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Halaman {pageIndex + 1} dari {pageOptions.length}</Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit" : "Tambah"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp; {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp; {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.resetForm();
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">Nama Berkas</Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Input nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="sort_order-field" className="form-label">No Urut</Label>
                            <Input name="sort_order" id="sort_order-field" className="form-control" placeholder="Isi No Urut" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sort_order} invalid={validation.touched.sort_order && validation.errors.sort_order ? true : false} />
                            {validation.touched.sort_order && validation.errors.sort_order ? <FormFeedback type="invalid">{validation.errors.sort_order}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              placeholder="Select Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              options={statusActiveData}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Input Keterangan (Jika ada)" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            setCompanyList([]);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ApplicantDocument;
